import { IApiService } from '../../../../types/src';

export class CRMService {
    client: IApiService;
    serviceName = 'api/v2/crm';

    constructor({ client }: { client: IApiService }) {
        this.client = client;
    }

    // Get receivers with pagination and filtering
    getReceivers(params: any = {}) {
        return this.client.get(`${this.serviceName}/receivers`, params);
    }

    // Get companies with pagination and filtering
    getCompanies(params: any = {}) {
        return this.client.get(`${this.serviceName}/companies`, params);
    }

    // Export receivers to CSV
    exportReceivers(params: any = {}) {
        return this.client.get(`${this.serviceName}/export_receivers`, params);
    }

    // Get total count of receivers
    getReceiversTotal(params: any = {}) {
        return this.client.get(`${this.serviceName}/receivers`, { ...params, only_total: true });
    }

    // Get total count of companies
    getCompaniesTotal(params: any = {}) {
        return this.client.get(`${this.serviceName}/companies`, { ...params, only_total: true });
    }

    exportCompanies(params: any = {}) {
        return this.client.get(`${this.serviceName}/export_companies`, params);
    }
}
